import React from "react";
import { Row, Col, Space } from "antd";
import { SectionCardWrapper } from "../../../Components/UI/SectionCardWrapper";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { mail_icon } from "../../../Assets/Images";
import { withScroll } from "../../../HOC/withScroll";
import {
  CustomLabel,
  SectionCardHeading,
  Wrapper,
} from "../../../Common/style";
import RejectedCard from "../../../Components/UI/RejectedCard";
import { useIsMobile } from "../../../Hooks";
import { PolicyDetails } from "../CommonData";

const PolicyCancelledPage = () => {
  const { policyNum, proposerFirstName, policyStatus } = PolicyDetails();
  const isMobile = useIsMobile();
  return (
    <section>
      <div className="container" style={{ marginTop: "150px" }}>
        <Wrapper>
          <Row justify="space-between" gutter={[32, { xs: 32 }]}>
            {isMobile && (
              <Col xs={24}>
                <RejectedCard label={`Policy ${policyStatus}`} />
              </Col>
            )}
            <Col lg={18} md={15}>
              <SectionCardWrapper>
                <Row gutter={[0, 24]}>
                  <Col span={24}>
                    <Space direction="vertical">
                      <SectionCardHeading>
                        Hi {proposerFirstName}!{" "}
                        <label
                          style={{
                            fontSize: "14px",
                            fontWeight: "normal",
                            display: "inline",
                          }}
                        >
                          Your Policy is {policyStatus}!
                        </label>
                      </SectionCardHeading>
                    </Space>
                  </Col>
                  <Col span={18} style={{ visibility: "hidden" }}>
                    <CustomLabel font_size="14" font_weight="normal">
                      Basis evaluation of insurance policy number {policyNum} by
                      our Medical Underwriters, we are sorry to inform that we
                      are unable to process your application. Your premium
                      amount shall be refunded to your bank account in 15 days.
                    </CustomLabel>
                  </Col>
                  <Col span={24}>
                    <CustomLabel font_size="14" font_weight="normal">
                      Incase on any queries,
                    </CustomLabel>
                    <CustomLabel font_size="14" font_weight="normal">
                      please reach out to our customer services on{" "}
                    </CustomLabel>
                  </Col>
                  <Col lg={18} md={24} xs={24}>
                    <Row gutter={[0, { xs: 24, md: 16 }]}>
                      <Col lg={12} md={24} xs={24}>
                        <a href="tel:18001024462">
                          <span style={{ fontSize: "14px" }}>
                            <FontAwesomeIcon icon={faPhone} color="#f26221" />
                            <span
                              style={{ color: "black", marginLeft: "20px" }}
                            >
                              1800 102 4462
                            </span>
                          </span>
                        </a>
                      </Col>
                      <Col lg={12} md={24} xs={24}>
                        <a href="mailto:customercare@manipalcigna.com">
                          <span style={{ fontSize: "14px" }}>
                            <img
                              src={mail_icon}
                              style={{
                                width: "24px",
                                height: "18px",
                                display: "inline",
                              }}
                            />
                            <span
                              style={{ color: "black", marginLeft: "20px" }}
                            >
                              customercare@manipalcigna.com
                            </span>
                          </span>
                        </a>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </SectionCardWrapper>
            </Col>
            {/* --------------------------Dummy card----------------------------------- */}
            <Col lg={6} md={9}>
              <Row gutter={[0, { lg: 32, md: 32, xs: 0 }]}>
                {!isMobile && (
                  <Col span={24}>
                    <RejectedCard label={policyStatus} />
                  </Col>
                )}
              </Row>
            </Col>
          </Row>
        </Wrapper>
      </div>
    </section>
  );
};

export default withScroll(PolicyCancelledPage);
